import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';

const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    height: 'calc(100vh - 64px)',
    maxHeight: 'calc(100vh - 64px)',
    margin: '32px auto'
  }
});

const StyledCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: '8px',
  top: '8px',
  color: theme.palette.grey[500]
}));

const StyledIframe = styled('iframe')({
  width: '100%',
  height: '100%',
  border: 'none'
});

function ChartFrameModal({ switchViews, setSwitchViews, url, defaultTab = 'chart' }) {
  const handleClose = () => {
    setSwitchViews(false);
  };

  return (
    <StyledDialog
      open={switchViews}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
    >
      <StyledCloseButton
        aria-label="close"
        onClick={handleClose}
        size="large"
      >
        <CloseIcon />
      </StyledCloseButton>
      <DialogContent sx={{ padding: 0 }}>
        <Box sx={{ height: '100%' }}>
          <StyledIframe
            src={url}
            title="Chart Frame"
            allow="fullscreen"
          />
        </Box>
      </DialogContent>
    </StyledDialog>
  );
}

export default ChartFrameModal; 